import { Sparkles } from "lucide-react";
import { useSearchParams } from "react-router-dom";

const SignIn = ({ login }) => {
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl');

  const handleLogin = () => {
    // Pass the return URL to the login function (default to subscription plans for new breeders)
    login(returnUrl || '/subscription-plans');
  };

  return (
    <div className="pt-16 min-h-screen bg-[#050505]">
      <section className="hero-section noise-overlay min-h-[70vh]">
        <div className="hero-bg">
          <img
            src="https://images.pexels.com/photos/39070/white-horse-white-horse-black-background-39070.jpeg"
            alt="Breedling sign in"
            loading="eager"
            decoding="sync"
            crossOrigin="anonymous"
            referrerPolicy="no-referrer"
          />
          <div className="hero-gradient absolute top-0 left-0 w-full h-full" />
        </div>

        <div className="hero-content">
          <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">Secure Sign In</p>
          <h1
            className="font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.1] text-[#EDEDED] mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Continue to Breedling
          </h1>
          <p className="text-base md:text-lg text-[#A1A1AA] font-light max-w-2xl mx-auto mb-10 leading-relaxed">
            Sign in to message breeders, register services, and manage your listings.
          </p>

          <div className="glass-card p-6 max-w-md mx-auto">
            <button
              onClick={handleLogin}
              className="btn-gold w-full flex items-center justify-center gap-2"
              data-testid="signin-continue-google"
            >
              <Sparkles className="w-4 h-4" />
              Continue with Google
            </button>

            <p className="text-xs text-[#71717A] mt-4">
              You'll be redirected to Google to complete authentication.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SignIn;
